import { Button } from './ui/button';
import { ThumbsUpIcon } from './ui/icons';
import { ReactionType } from '../types/Reaction.type';
import { QuestionReaction } from '../types/Question.type';

interface UserReactionsProps {
  questionId: string;
  onClickReaction: (reaction: ReactionType) => void;
  questionReaction: QuestionReaction;
}
/**
 * 유저 좋아요/싫어요 컴포넌트
 *
 * @author hjkim
 * @constructor
 */
const UserReactions = ({ questionId, onClickReaction, questionReaction }: UserReactionsProps) => {
  /**
   * Handlers
   */
  /* 좋아요 버튼 클릭 핸들러 */
  const handleLike = () => {
    console.log(`Liked question with ID: ${questionId}`);
    onClickReaction('LIKE');
    // 여기에 좋아요 API 호출 로직 추가
  };
  /* 싫어요 버튼 클릭 핸들러 (추후 적용) */
  // const handleHate = () => {
  //   console.log(`Disliked question with ID: ${questionId}`);
  //   onClickReaction('DISLIKE');
  // };
  return (
    <div className="flex items-center gap-3">
      {/* 좋아요 */}
      <Button
        variant={questionReaction.userReaction === 'LIKE' ? 'default' : 'outline'}
        size="sm"
        onClick={handleLike}
        className={`flex items-center gap-2 h-9 px-4 transition-all duration-200 ${questionReaction.userReaction === 'LIKE' ? 'bg-green-600 hover:bg-green-700 text-white border-green-600' : 'hover:bg-green-50 hover:text-green-700 hover:border-green-300'}`}>
        <ThumbsUpIcon />
        <span>{questionReaction.likeCount}</span>
      </Button>
      {/* 싫어요 (추후 적용) */}
      {/* <Button
        variant={questionReaction.userReaction === 'DISLIKE' ? 'destructive' : 'outline'}
        size="sm"
        onClick={handleHate}
        className={`flex items-center gap-2 h-9 px-4 transition-all duration-200 ${questionReaction.userReaction === 'DISLIKE' ? 'bg-red-600 hover:bg-red-700 text-white border-red-600' : 'hover:bg-red-50 hover:text-red-700 hover:border-red-300'}`}>
        <ThumbsDownIcon />
        <span>{questionReaction.dislikeCount}</span>
      </Button> */}
    </div>
  );
};

export default UserReactions;
